/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import Numerical from './Numerical';

class NumericalDivInput extends React.Component {

    state: State = {
        keyboardVisible: false
    };

    static propTypes = {
        value: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.number
        ]),
        className: React.PropTypes.string.isRequired,
        title: React.PropTypes.string.isRequired,
        onSubmit: React.PropTypes.func.isRequired,
        label: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.openKeyboard = this.openKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    openKeyboard(open) {
        this.setState({keyboardVisible: open});
    }

    onSubmit(val) {
        const {onSubmit} = this.props;
        onSubmit(val);
        this.openKeyboard(false);
    }

    render() {
        const {keyboardVisible} = this.state;
        const {value, className, title, label} = this.props;
        const val = typeof value === 'undefined' ? '' : value;

        return (
            <div className={className}>
                <div className="form-row" onClick={() => this.openKeyboard(true)}>
                    <label className="form-label">{title}:</label>
                    <input className="form-input text-center" readOnly value={val}/>
                </div>
                {keyboardVisible &&
                <Numerical defaultValue={val}
                           label={label}
                           onClose={() => this.openKeyboard(false)}
                           onSubmit={this.onSubmit}/>
                }
            </div>
        );
    }
}

export default connect(state => ({}))(NumericalDivInput);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/NumericalDivInput.js